"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var BuildSession_1 = __importDefault(require("./BuildSession"));
var FinanceCalculator_1 = __importDefault(require("./FinanceCalculator"));
var UI_1 = __importDefault(require("./UI"));
var ToastMessages_1 = __importDefault(require("./ToastMessages"));
var EnvironmentInfo_1 = __importDefault(require("./EnvironmentInfo"));
exports.default = redux_1.combineReducers({
    BuildSession: BuildSession_1.default,
    FinanceCalculator: FinanceCalculator_1.default,
    UI: UI_1.default,
    ToastMessages: ToastMessages_1.default,
    EnvironmentInfo: EnvironmentInfo_1.default
});
//# sourceMappingURL=index.js.map